var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import { checkAuthSlice } from './slice-components/check-auth';
import { logoutSlice } from './slice-components/logout';
import { loginSlice } from './slice-components/login';
var initialState = {
    pending: false,
    error: null,
    isSigningOut: false,
    isAuthenticated: null,
};
export var formikInitialValue = {
    username: '',
    password: '',
    code: '',
    remember: false,
};
export var formikQRCodeInitialValue = {
    code: '',
};
var authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: __assign(__assign(__assign({}, loginSlice), logoutSlice), checkAuthSlice),
});
export var loginRequestSuccess = (_a = authSlice.actions, _a.loginRequestSuccess), loginRequestFailed = _a.loginRequestFailed, checkAuthSuccess = _a.checkAuthSuccess, checkAuthFailed = _a.checkAuthFailed, logoutRequestSuccess = _a.logoutRequestSuccess, logoutRequestFailed = _a.logoutRequestFailed, updateUserInfoSuccess = _a.updateUserInfoSuccess;
export default authSlice.reducer;
